import React from "react";
import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import { RootNavigation } from "../navigation/rootNavigation";
import store from "../store/config";
import theme from "../theme/theme";

function App() {
  return (
    <Provider store={store}>
      <ConfigProvider theme={theme}>
        <RootNavigation />
      </ConfigProvider>
    </Provider>
  );
}

export default App;
